import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $('.datepicker').flatpickr({ dateFormat: "m/d/Y" });
    $('.datepicker-current').flatpickr({ dateFormat: "m/d/Y", defaultDate: new Date(Date.now() + 5 * 24*60*60*1000) });
    $('.runtime').flatpickr({ enableTime: true, noCalendar: true, dateFormat: "H:i" });
  }
}